import React from 'react';
import SettingsPage from './Page.tsx';
import PageFade from '@/common/components/PageFade.tsx';

const SettingsRoute: React.FC = () => {
  return (
    <PageFade>
      <SettingsPage />
    </PageFade>
  );
};

export default SettingsRoute;
